const messages = {
    // fallbackLng
    es: {
        // ns e defaultNS 
        translations: {
            titles: {
                homeTitle: 'Aqcion'
            },
            navbar: {
                op1: 'Inicio',
                op2: 'Cliente',
                op3: 'Equipo',
                op4: 'Contacto',
                op5: 'Páginas',
                op6: 'Aqcion Blog',
                },
            homeMessages: {
                homeText: 'Bienvenido a nuestra empresa de desarrollo de proyectos y sitios web, fundada en 2023 con el objetivo de brindar soluciones digitales de alta calidad a nuestros clientes.',
                homeText2: 'Somos un equipo apasionado por la tecnología y la innovación, siempre buscamos las mejores prácticas y las últimas tendencias del mercado para ofrecer servicios de excelencia.'
                },
            servicosMessages: {
                text1: 'Servicios',
                text2: 'Ofrecemos',
                text3: 'Con la creciente popularidad del código QR en todo el mundo, es importante contar con una empresa especializada en esta tecnología para garantizar que tus proyectos se ejecuten con eficiencia y calidad. Con nuestra tecnología en código QR, ofrecemos servicios especializados para crear soluciones innovadoras y prácticas para empresas y usuarios finales. Esto permite implementar estrategias de marketing efectivas, aumentar la seguridad y optimizar procesos.',
                titleservicos1: 'Proyectos',
                textservicos1: 'Nos aseguramos de alcanzar metas, ideas y tus expectativas de éxito.',

                titleservicos2: 'Capacitación',
                textservicos2: 'Ofrecemos capacitación en manejo y mantenimiento, así como capacitación en software.',

                titleservicos3: 'Tecnología',
                textservicos3: 'Brindamos a nuestros clientes tecnologías avanzadas y actuales.',

                titleservicos4: 'Soporte',
                textservicos4: 'Brindamos soporte para nuestros servicios, capacitación al cliente y atención directa.',
            },
            notaMessages: {
                text1: 'etiquetas',
                text2: 'Aqcion Digital',
                
                textparagrafo1: 'Entendemos que cada cliente tiene necesidades únicas, por eso ofrecemos un servicio personalizado y enfocado en las necesidades específicas de cada proyecto. Desde la concepción de la idea hasta la entrega final del producto, trabajamos en estrecha colaboración con nuestros clientes para asegurarnos de que las soluciones que desarrollamos cumplan con sus expectativas y necesidades.',
                textparagrafo2: 'Nuestro equipo también brinda servicios de mantenimiento, asegurándonos de que los proyectos y sitios web se mantengan actualizados y funcionando sin problemas. Realizamos pruebas regulares para garantizar que todo funcione perfectamente y solucionamos cualquier problema que pueda surgir.',
                textparagrafo3: 'Además, ofrecemos servicios de capacitación para que nuestros clientes puedan mantener sus sitios web y proyectos actualizados y en pleno funcionamiento. Con capacitaciones personalizadas, nuestros clientes tienen la oportunidad de aprender las habilidades necesarias para gestionar y actualizar sus propios proyectos, volviéndose más autónomos y reduciendo los costos de mantenimiento.',
                textparagrafo4: 'Nos comprometemos a brindar soluciones digitales de calidad que satisfagan las necesidades de nuestros clientes y, al mismo tiempo, superen sus expectativas. Contáctanos para obtener más información sobre nuestros servicios y cómo podemos ayudarte a alcanzar tus objetivos digitales.',
            },
            faq: {
                title: 'Preguntas frecuentes',
                subtitle: '¿Alguna pregunta?',
                text: 'Aquí tienes algunas preguntas que recibimos con frecuencia y sus respuestas.',
                
                pergunta1: '¿Aqcion ofrece entrenamiento y soporte para soluciones de software?',
                resposta1: 'Ofrecemos entrenamiento y soporte para soluciones de software para ayudarte a aprender a utilizarlo de manera efectiva y eficiente. También brindamos soporte técnico continuo para garantizar que el software funcione correctamente y ayudamos a resolver cualquier problema que pueda surgir.',

                pergunta2: '¿Cómo funciona la ley LGPD?',
                resposta2: 'Seguimos las pautas establecidas por la Ley General de Protección de Datos (LGPD) y adoptamos medidas técnicas y organizativas adecuadas para garantizar la protección de los datos personales.',

                pergunta3: '¿Mis expectativas serán cumplidas?',
                resposta3: 'En Aqcion Digital garantizamos que tus expectativas sean cumplidas. Para lograrlo, seguimos buenas prácticas, como comprender las necesidades del cliente, una comunicación clara sobre el proceso a realizar, establecimiento de metas, entre otros.',

                pergunta4: '¿Cómo se mantiene Aqcion al día con las últimas tendencias tecnológicas?',
                resposta4: 'Invertimos en investigación y desarrollo de nuevas tecnologías y mejoramiento de las existentes, manteniéndonos al día con el mercado y contando con profesionales calificados para gestionar e implementar tecnologías de vanguardia.',

                pergunta5: '¿Por qué QR Code e IA?',
                resposta5: 'Una empresa innovadora utiliza código QR e inteligencia artificial para ofrecer una experiencia de compra más eficiente y personalizada a sus clientes.',

                pergunta6: '¿Aqcion es confiable?',
                resposta6: 'Demostramos capacidad para cumplir con nuestras obligaciones y promesas a los clientes, somos una empresa transparente y abierta a una comunicación clara, ¡y ofrecemos un trabajo de total calidad!',
            },
            feedbacks: {
                title: 'Opiniones',
                subtitle: 'Lo que dicen nuestros clientes sobre nosotros',
                text: 'Nuestro enfoque principal es construir relaciones sólidas con nuestros clientes.',
                
                feed1: '“Estoy muy impresionado con el trabajo de Aqcion Digital. Desarrollaron un sitio web personalizado para mi empresa que es fácil de usar y mejoró significativamente nuestra eficiencia operativa. El equipo de desarrollo fue profesional y trabajó conmigo para asegurarse de que la aplicación cumpliera con mis necesidades específicas.',
                feed2: '“El proceso de desarrollo fue muy fluido y el equipo de desarrollo fue muy receptivo a nuestras necesidades. No podríamos estar más satisfechos con el resultado final.',
                feed3: '“Fueron muy accesibles durante todo el proceso de desarrollo y hicieron un excelente trabajo manteniéndonos actualizados sobre el progreso del proyecto. Los recomendaría a todos aquellos que necesiten servicios de desarrollo de tecnología.',

                tecnologias: 'Algunas tecnologías que utilizamos',
            },
            ceo: {
                title: 'CEO',
                subtitle: 'Equipo',
                text: 'Equipo de Desarrolladores y Fundadores de Aqcion Digital.',

                nome1: 'Luiz Felipe Menezes',
                cargo1: 'Gerente de Investigación y Desarrollo',

                nome2: 'Thaiza Favarelli',
                cargo2: 'Desarrollador FullStack',

                nome3: 'Gustavo Nonato',
                cargo3: 'Gerente de Redes Sociales y Publicidad',
            },
            contato: {
                title: 'CONTÁCTANOS',
                text1: '¡Nos encanta escucharte!',
                text2: 'Resuelve tus dudas, ponte en contacto.',
                text3: '¿Cómo podemos ayudarte?',

                email: 'aqcionDigi@gmail.com',
                titleforms: 'Envíanos un mensaje',
                lblnome: 'Nombre completo*',
                lblemail: 'Email*',
                lblPhone: 'Número de contacto*',
                lblmensagem: 'Mensaje*',
                btnenviar: 'Enviar mensaje',
            },
            footer: {
                text: '¡Transformamos ideas en innovación tecnológica, impulsando el presente y creando el futuro!',
                tecnologia: 'Algunas tecnologías que ofrecemos',
                by: 'Diseño y desarrollo por',
            },
            pageblog: {
                title1: 'Herramientas de desarrollo',
                text1: 'En nuestra empresa, siempre estamos buscando las tecnologías más avanzadas para el desarrollo de proyectos increíbles. Utilizamos una variedad de herramientas y tecnologías de vanguardia para garantizar resultados excepcionales para nuestros clientes.',
                title2: 'Algunas tecnologías utilizadas',
                text2: '✨ Una de nuestras principales tecnologías es Firebase, que nos permite crear aplicaciones web y móviles con potentes características de almacenamiento en la nube, autenticación de usuarios y notificaciones en tiempo real. Con él, ofrecemos una experiencia ágil y segura a los usuarios de nuestros productos.',
                text3: '💻 Además, contamos con React y FlutterFlow, frameworks de desarrollo de interfaces que nos permiten crear interfaces modernas y receptivas para nuestras aplicaciones. Con ellos, garantizamos una experiencia de usuario fluida, independientemente de la plataforma utilizada.',
                text4: '🌐 Para el desarrollo de nuestro backend, confiamos en Django y MySQL. Con estas tecnologías robustas, creamos sistemas escalables, seguros y eficientes, capaces de manejar grandes volúmenes de datos y garantizar la estabilidad de nuestras aplicaciones.',
                text5: '💰 Para las transacciones financieras en línea, utilizamos Stripe, una plataforma segura y confiable de pagos electrónicos. Esto nos permite ofrecer una experiencia de compra tranquila y segura para nuestros clientes, aumentando la confianza y la satisfacción.',
                text6: '⚡ Y finalmente, para el desarrollo del frontend, contamos con Tailwind y HTML, que nos permiten crear diseños receptivos y estilos personalizados, garantizando una apariencia moderna y atractiva para nuestras aplicaciones y sitios web.',
                text7: '#tecnologíaavanzada #desarrollodeproyectos #innovación #experienciadelusuario #resultadosexcepcionales',
                text8: '🚀 Con esta amplia gama de tecnologías avanzadas, estamos listos para desarrollar proyectos increíbles y ofrecer soluciones innovadoras a nuestros clientes. ¡Contáctanos y descubre cómo podemos impulsar tu negocio al siguiente nivel!',

                fraseaqcion: 'La vida es mejor para aquellos que hacen lo posible para obtener lo mejor.',

                cardtext1: '¡Mantente al día con proyectos innovadores!',
                cardtext2: 'Haz un buen uso de la tecnología siempre.',

                fraseaqcion2: 'Convertimos ideas en realidad, impulsando el potencial digital para conquistar el futuro.',

                topictitle1: 'Misión',
                topictitle2: 'Visión',
                topictitle3: 'Valores',

                topicname1: 'Soluciones tecnológicas',
                topicname2: 'Reconocimiento',
                topicname3: 'Enfoque, valoración, innovación, calidad',

                topictext1: 'Desarrollar soluciones tecnológicas innovadoras y personalizadas para satisfacer las necesidades de nuestros clientes. Superar las expectativas de los clientes y contribuir a su éxito. Además, ofrecer capacitación para capacitar a los clientes a utilizar nuestras soluciones de manera eficiente.',
                topictext2: 'Aqcion Digital tiene como visión ser reconocida como referencia en el mercado de desarrollo de tecnologías personalizadas, con calidad y excelencia.',
                topictext3: 'Nuestra empresa prioriza la excelencia en la atención al cliente, con enfoque, trabajo en equipo y transparencia. Buscamos calidad e innovación en todas las etapas del desarrollo, brindando soluciones creativas y disruptivas para obtener una ventaja competitiva.',

            },
            idioma: {
                text: 'Selecciona un idioma',
            },
            maps: {
                title: 'Soporte técnico:',
                suporte: '19 99423-8412',
                email: 'aqciondigi@gmail.com',
                text1: 'Informar errores y hacer preguntas.',
                text2: '¡Obtener un presupuesto!',
                endereco : 'Ubicación: Av. Brasil Sur, 2001 - Parque Res. Nardini, Americana - SP, 13465-770',
            }
        }
    }
}

export { messages }